/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col, Panel, Row} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, propTypes, reduxForm } from 'redux-form';
import { isLocal } from '../../../../reducers/localId/localId';
import { remove as removeAction, save as saveAction } from '../../../../reducers/projects/projects.actions';
import SelectFormGroup from '../../../Forms/SelectFormGroup/SelectFormGroup';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import UnsavedChangesPrompt from '../../../UnsavedChangesPrompt/UnsavedChangesPrompt';
import './ProjectForm.css';
import { clients as clientProperty } from '../../../../reducers/clients/clients.reducer';
import { load } from '../../../../reducers/clients/clients.actions';
import CheckboxFormGroup from '../../../Forms/CheckboxFormGroup/CheckboxFormGroup';

// eslint-disable-next-line object-curly-newline
export class ProjectForm extends React.Component {
  constructor() {
    super();
    this.state = {
      showFields: false,
    };
  }

  componentDidMount() {
    this.props.loadClients();
  }

  render() {
    const {
      submitting,
      dirty,
      remove,
      save,
      initialize,
      handleSubmit,
      clients,
      project: { name, removing, id },
    } = this.props;

    return (
      <span>
        {dirty && <UnsavedChangesPrompt dirty />}
        <Row style={{'margin-top': "-14px"}}>
          <Col md={1}><Button style={{'height': "14px", "padding": "5px 15px 20px 15px", "font-size": "14px"}} onClick={() => this.setState({showFields: !this.state.showFields})}>Edit</Button></Col>
          <Col md={11} style={{'font-size': "14px"}}>{name}</Col>
        </Row>
        <Panel>

        {(this.state.showFields || id.toString().includes('LOCAL')) &&
        <Form
          onSubmit={
            handleSubmit(values =>
              save(values, id)
                .then(client => initialize(client.response)))}
        >
          <Row>
            <Col md={12}>
              <Field
                component={TTFormGroup}
                name="name"
                label="Name"
                type="text"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Field
                component={TTFormGroup}
                name="number"
                label="Number"
                type="text"
                required
              />
            </Col>
            <Col md={4}>
              <Field
                component={SelectFormGroup}
                name="client_id"
                label="Client"
                options={clients}
                required
              />
            </Col>
            <Col md={2}>
              <Field
                component={CheckboxFormGroup}
                name="active"
                label="Is Active"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={submitting}
                type="submit"
                dirty={dirty}
              >
                {isLocal(id) ? 'Add' : 'Save'}
              </SpinnerButton>
            </Col>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={removing}
                onClick={() => remove(id)}
                bsStyle="danger"
              >
                Remove
              </SpinnerButton>
            </Col>
          </Row>
        </Form>
        }
        </Panel>
      </span>);
  }
}

ProjectForm.propTypes = {
  ...propTypes,
  project: PropTypes.shape({
    isRemoving: PropTypes.bool.isRequired,
  }).isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.project,
  form: `project${ownProps.project.id}`,
  clients: clientProperty(state),
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  save: (values, id) => dispatch(saveAction({ ...values, id })),
  loadClients: () => dispatch(load()),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(ProjectForm));



// WEBPACK FOOTER //
// ./src/components/Admin/Projects/ProjectForm/ProjectForm.jsx